import React, { useState } from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function ObjetivoV2AccordionCard({
  titulo,
  subtitulo = "",
  mt = 2,
  children,
  defaultExpanded = false,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (expanded) {
          setExpanded(false);
        }
      }}
    >
      <MDBox mt={mt}>
        <Accordion
          expanded={expanded}
          onChange={(_, novoExpanded) => setExpanded(novoExpanded)}
          disableGutters
          sx={{
            backgroundColor: "#fff7f0",
            borderRadius: 2,
            "&:before": {
              display: "none",
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
            sx={{
              minHeight: 32,
              px: 1.5,

              "& .MuiAccordionSummary-content": {
                margin: "4px 0",
                minWidth: 0,
              },
            }}
          >
            <MDBox minWidth={0}>
              <MDTypography variant="button" sx={{ fontSize: 13 }}>
                {titulo}
              </MDTypography>

              {expanded && subtitulo && (
                <MDTypography variant="caption" color="text" display="block" mt={0.25}>
                  {subtitulo}
                </MDTypography>
              )}
            </MDBox>
          </AccordionSummary>

          <AccordionDetails
            sx={{
              pt: 0,
              pb: 1.5,
              px: 1.5,
            }}
          >
            {children}
          </AccordionDetails>
        </Accordion>
      </MDBox>
    </ClickAwayListener>
  );
}
